import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import ReactApexChart from 'react-apexcharts'
import { recentChart } from '../../../Data/Dashboard/Ecommerce'

export default function OrderActivity() {
    return (
        <Col xxl={5} md={6} className="box-col-6">
            <Card className="sales-summary">
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Order Activity "} />
                <CardBody className="p-2 pb-0">
                    <div className="medium-chart">
                        <div className="recent-chart" id="recent-chart">
                            <ReactApexChart options={recentChart} series={recentChart.series} type='area' height={360} />
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
